module.exports = __webpack_public_path__ + "img/icon_sm_cyrb.437bc71b.png";